import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import ButtonComponent from "../../components/atoms/ButtonComponent";
import InputComponent from "../atoms/InputComponent";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";

function Searching({ onUpdateTableData }) {
  const [info, setInfo] = useState("");
  const [buttonColor, setButtonColor] = useState("#b5bac9");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { t } = useTranslation();

  const handleRequest = () => {
    if (!isButtonDisabled) {
      onUpdateTableData(info);
    }
  };

  const handleInputChange = (newValue) => {
    setInfo(newValue);
    updateButtonState(newValue);
  };

  const updateButtonState = (inputValue) => {
    const isValid = inputValue.trim() !== "";
    setIsButtonDisabled(!isValid);
    setButtonColor(isValid ? "#73c883" : "#b5bac9");
  };

  return (
    <Stack sx={{ width: "100%", alignItems: "end" }}>
      <Stack sx={{ width: "100%" }}>
        <Stack>
          <Typography color="white" fontSize="18px" marginTop="1.5rem">
            {t("Welcome.text62")}
          </Typography>
        </Stack>

        <Stack
          sx={{
            width: "100%",
          }}
        >
          <InputComponent
            value={info}
            onChange={handleInputChange}
            fullWidth
            backgroundColor="white"
            fontSize="15px"
            textColor="gray"
          />
        </Stack>
      </Stack>

      <Stack sx={{ width: "6rem", marginTop: "1rem" }}>
        <ButtonComponent
          label="Buscar"
          onClick={handleRequest}
          backgroundColor={buttonColor}
          disabled={isButtonDisabled}
        />
      </Stack>
    </Stack>
  );
}
export default Searching;
